import { set } from 'lodash';

export const generateOnChange =
	(setProp: Function, attrName: string) => (value: any) => {
		setProp((props: { [x: string]: string }) => {
			set(props, attrName, value);
		});
	};
